import React from 'react'

function Factures() {
    return (
        <div>Factures</div>
    )
}

export default Factures